import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { Icon } from "@/lib/icons";

const KIND_ICON = {
  member: "Users", visitor: "UserPlus", event: "Calendar", grant: "Landmark",
  code: "TicketPercent", partner: "Handshake", board_meeting: "Gavel", reward: "Gift",
};

export default function RecentlyAdded() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => {
    api.get("/my/recent-creates").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    const h = () => setTimeout(load, 800); // refresh shortly after any create/navigation
    window.addEventListener("rca:navigate", h);
    return () => window.removeEventListener("rca:navigate", h);
  }, [load]);

  const open = (it) => {
    if (it.kind === "member" && it.entity_id) sessionStorage.setItem("rca_open_member", it.entity_id);
    window.dispatchEvent(new CustomEvent("rca:navigate", { detail: { section: it.section } }));
  };

  if (items.length === 0) return null;
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1 mb-4" data-testid="recently-added-strip">
      <span className="text-[11px] font-bold uppercase tracking-wide text-ink/45 shrink-0">Recently added</span>
      {items.map((it) => (
        <button
          key={`${it.entity_id}-${it.at}`}
          data-testid={`recent-${it.entity_id}`}
          onClick={() => open(it)}
          className="shrink-0 inline-flex items-center gap-1.5 bg-cream border border-ink/15 rounded-full pl-2.5 pr-3 py-1.5 text-[13px] hover:border-maroon/40 hover:-translate-y-0.5 transition-transform"
          title={`Open ${it.label}`}
        >
          <Icon name={KIND_ICON[it.kind] || "Plus"} className="w-3.5 h-3.5 text-maroon" />
          <span className="max-w-[160px] truncate">{it.label}</span>
        </button>
      ))}
    </div>
  );
}
